import React from 'react';
import BottomButtons from '../../shared/BottomButtons/BottomButtons';
import { BigEnvelope, GetPostal } from '../../constants/assets';

const Postal = (props) => {
    const { number, urlImage, goToPlaySection } = props;
    // const urlToShare = encodeURIComponent(window.location.href);
    const urlToShare = encodeURIComponent(urlImage);

    const shareOnFB = () => {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + urlToShare, "_blank");
    };

    return (
        <div className="postal-section">
            { /* <h1 className="font-sep text-center">Postal</h1> */ }
            <button onClick={goToPlaySection} className="close-top-button"></button>
            <GetPostal number={number} />
            <BigEnvelope />
            <button onClick={shareOnFB} className="share-button"></button>
            <BottomButtons
                customClass="justify-bottom"
                logo
            />
        </div>
    );
};

export default Postal;
